export default __webpack_public_path__ + "static/O0259-43f5fce390be609e5b3ca9e2737341e7.png";